import React from 'react';
import { Accordion } from './ui/Accordion';
const FAQS = [{
  question: '¿Cómo recibo el material?',
  answer: 'El acceso es digital e inmediato. Después de la compra recibís los archivos en PDF para descargar y usar cuando quieras.'
}, {
  question: '¿Para quién está pensado?',
  answer: 'Para estudiantes que ya están en prácticas o internado y para enfermeros junior recién graduados que necesitan ganar criterio y seguridad en la práctica real.'
}, {
  question: '¿Puedo verlo desde el celular?',
  answer: 'Sí. El material es compatible con celular, tablet y computadora, sin instalar nada. Los 5 bonos están pensados justamente para consultarlos desde el celular en plena práctica.'
}, {
  question: '¿Incluye farmacología y cálculos?',
  answer: 'Sí. El Tomo 5 está dedicado a farmacología aplicada y cálculo de dosis, y además incluye la Guía Express de Medicación y Cálculos como bono.'
}, {
  question: '¿Los casos clínicos están desarrollados paso a paso?',
  answer: 'Sí. El Tomo 6 incluye casos clínicos resueltos con análisis, priorización y errores frecuentes explicados paso a paso.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí, tienes 7 días de garantía. Si no es lo que esperabas, puedes solicitar la devolución del 100% de tu compra.'
}];
export function FAQ() {
  return <section className="py-10 md:py-16 bg-white" data-id="element-69" data-mp="11wp8fxuee03k">
      <div className="max-w-[760px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70" data-mp="11vxqhptq40vr">
        <div className="text-center mb-6 md:mb-8" data-id="element-71" data-mp="16p0k1xyi3aby">
          <p className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-2.5" data-id="element-72" data-mp="16ps369awvflc">
            Preguntas frecuentes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-clinical-deep leading-[1.08] uppercase" data-id="element-73" data-mp="wynqxhcme8u7">
            Lo que más nos{' '}
            <span className="accent-italic normal-case" data-id="element-74" data-mp="mzq72rq533hj">preguntan</span>
          </h2>
        </div>

        <div className="space-y-2.5" data-id="element-75" data-mp="2pmdci2c23cra">
          {FAQS.map(faq => <Accordion key={faq.question} title={faq.question} data-id="element-76" data-mp="2poq4l8bj33i2">
              <p className="text-[14px] md:text-[15px] text-clinical-ink leading-relaxed" data-id="element-77" data-mp="2kv51j1v2vjc0">
                {faq.answer}
              </p>
            </Accordion>)}
        </div>
      </div>
    </section>;
}